module.exports = __webpack_public_path__ + "img/macbook.4c79796d.jpg";